import dynamic from 'next/dynamic'

export const CONTACTUS_COMPONENTS_MAPPING = {
  'contact-us.contact-channel': dynamic(() => import('@components/ContactUsV2/ContactChannelBase')),
  'contact-us.bot-channel': dynamic(() => import('@components/ContactUsV2/BotChannel/BotChannel')),
  'acko-homepage.download-app-banner': dynamic(() => import('@components/UserStatsAndAppLink/UserStatsAndAppLink')),
}

export const CONTACT_US_EVENTS = {
  // Page View Events
  PAGE_VIEWED: {
    eventName: 'page_viewed',
    eventProps: {
      journey: 'contact_us',
    },
  },
  CALL_HELPLINE_PAGE_VIEWED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_callus',
    },
  },
  EMAIL_US_PAGE_VIEWED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_email',
    },
  },
  GRIEVANCE_PAGE_VIEWED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_grievance',
    },
  },

  // Tap Button Interaction Events
  TAP_CTA: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us',
    },
  },

  // Mobile-specific tap events
  MOBILE_TAP: {
    eventName: 'tap_btn_interaction',
    eventProps: {},
  },
}

export const eventConfig = {
  Phone: {
    eventName: CONTACT_US_EVENTS.CALL_HELPLINE_PAGE_VIEWED.eventName,
    eventProps: CONTACT_US_EVENTS.CALL_HELPLINE_PAGE_VIEWED.eventProps,
  },
  Email: {
    eventName: CONTACT_US_EVENTS.EMAIL_US_PAGE_VIEWED.eventName,
    eventProps: CONTACT_US_EVENTS.EMAIL_US_PAGE_VIEWED.eventProps,
  },
}

export const CONTACT_US_CTA_MAPPING = {
  'I want to raise a claim': 'copy1_raise_claim',
  'I want my policy copy': 'copy2_policy_copy',
  'I want to edit my policy': 'copy3_edit_policy',
  'What does my policy cover': 'copy4_coverage',
  'I want to buy insurance': 'copy5_buy_policy',
  'I want to track my claim': 'copy6_track_claim',
  'Help me with something else': 'copy7_other',
}
